import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const WorkflowFiltersCard = ({ searchTerm, setSearchTerm, filterActive, setFilterActive }) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle>{t('approvalComp.filtersTitle')}</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="search">{t('approvalComp.searchLabel')}</Label>
          <div className="relative">
            <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input
              id="search"
              placeholder={t('approvalComp.searchPlaceholder')}
              className="pl-8"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="filter-active">{t('approvalComp.statusLabel')}</Label>
          <Select value={filterActive} onValueChange={setFilterActive}>
            <SelectTrigger id="filter-active">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('approvalComp.statusAll')}</SelectItem>
              <SelectItem value="active">{t('approvalComp.statusActive')}</SelectItem>
              <SelectItem value="inactive">{t('approvalComp.statusInactive')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </CardContent>
  </Card>
  );
};

export default WorkflowFiltersCard;
